import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { InputModule } from '@epicuro-next/ataraxia/input';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';

import { MultiRangeSliderComponent } from './component/multi-range-slider.component';

/**
 * Multi range slider Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective,
    IconsModule,
    InputModule,
  ],
  declarations: [MultiRangeSliderComponent],
  exports: [MultiRangeSliderComponent],
})
export class MultiRangeSliderModule {}
